import { gql } from "@apollo/client";

export const GET_ALL_DONATION_TYPES = gql`
  query GetAllDonationTypes {
    getAllDonationTypes {
      donation_type_id
      type_name
      description
      is_active
      createdAt
     
    }
  }
`;


export const GET_DONATION_TYPE_BY_ID = gql`
  query GetDonationTypeById($donation_type_id: ID!) {
    getDonationTypeById(donation_type_id: $donation_type_id) {
      donation_type_id
      type_name
      description
      is_active
      createdAt
    
    }
  }
`;

export const CREATE_DONATION_TYPE = gql`
  mutation CreateDonationType($input: createDonationTypeInput) {
    createDonationType(input: $input) {
      donation_type_id
      type_name
      description
      is_active
      createdAt
      
    }
  }
`;


export const UPDATE_DONATION_TYPE = gql`
  mutation UpdateDonationType($input: updateDonationTypeInput) {
    updateDonationType(input: $input) {
      donation_type_id
      type_name
      description
      is_active
    }
  }
`;


export const DELETE_DONATION_TYPE = gql`
  mutation DeleteDonationType($donation_type_id: ID!) {
    deleteDonationType(donation_type_id: $donation_type_id)
  }
`;
